import { render } from "./EmployeeHome.vue?vue&type=template&id=ba6bf934"
import script from "./EmployeeHome.vue?vue&type=script&lang=js"
export * from "./EmployeeHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__